<template>
  <KTCard ref="preview" v-bind:title="title" v-bind:example="true">
    <template v-slot:title v-if="hasTitleSlot">
      <h3 class="card-title">
        <slot name="title"></slot>
      </h3>
    </template>
    <template v-slot:toolbar>
      <div class="example-tools justify-content-center">
        <div class="card-toolbar">
          <slot name="toolbar"></slot>
        </div>
        <span
          class="example-toggle"
          data-toggle="tooltip"
          v-b-tooltip.hover.top="'View code'"
          v-show="false"
        />
        <span
          class="example-copy"
          data-toggle="tooltip"
          v-b-tooltip.hover.top="'Copy code'"
          v-show="false"
        />
      </div>
    </template>
    <template v-slot:body>

      <slot name="preview"></slot>
    </template>
    <template v-slot:foot v-if="hasFootSlot">
      <slot name="foot"></slot>
    </template>
  </KTCard>
</template>

<script>
import KTCard from '@/view/content/Card.vue';

export default {
  name: 'KTCodePreview',
  props: {
    title: String,
  },
  data() {
    return {
      tabIndex: 0,
      isOpen: false,
    };
  },
  components: {
    KTCard,
  },
  mounted() {
    // init example codes
    this.$nextTick(() => {
      //KTLayoutExamples.init([this.$el]);
      const hljs = this.$el.querySelectorAll('.hljs');
      hljs.forEach((hl) => {
        hl.classList.add(`language-${hl.classList[1]}`);
        hl.classList.remove('hljs');
      });
    });
  },
  methods: {
    /**
     * Set current active on click
     * @param event
     */
    setActiveTab(event) {
      // get all tab links
      const tab = event.target.closest('[role="tablist"]');
      const links = tab.querySelectorAll('[data-toggle="tab"]');
      // remove active tab links
      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove('active');
      }

      // set current active tab
      event.target.classList.add('active');

      // set clicked tab index to bootstrap tab
      this.tabIndex = parseInt(event.target.getAttribute('data-tab'));
    },
  },
  computed: {
    /**
     * Check if has title
     * @returns {boolean}
     */
    hasTitleSlot() {
      return !!this.$slots['title'];
    },

    /**
     * Check if has foot
     * @returns {boolean}
     */
    hasFootSlot() {
      return !!this.$slots['foot'];
    },

    /**
     * Check if code only has one, exclude the tabs
     * @returns {boolean}
     */
    hasSingleCodeType() {
      let exist = 0;
      ['html', 'js', 'scss'].forEach((type) => {
        if (this.$slots.hasOwnProperty(type)) {
          exist++;
        }
      });
      return exist === 1;
    },

    /**
     * Custom generate codes
     * @returns {boolean}
     */
    hasGeneralCode() {
      return !!this.$slots['code'];
    },

    /**
     * Check if has JS code slot
     * @returns {boolean}
     */
    hasJsCode() {
      return !!this.$slots['js'];
    },

    /**
     * Check if has SCSS code slot
     * @returns {boolean}
     */
    hasScssCode() {
      return !!this.$slots['scss'];
    },

    /**
     * Check if has HTML code slot
     * @returns {boolean}
     */
    hasHtmlCode() {
      return !!this.$slots['html'];
    },
  },
};
</script>
